import { EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { API_INFO } from "@client/lib/api";
import { getNoImageUrl } from "@client/lib/assets";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { downloadInvoice, setShowingDetailId, updateDetail } from "../actions";
import { localStateSelector } from "../selectors";
import { type MemberRecurringOrders } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  apiInfo: API_INFO,
  detail: null,
  id: "",
  isEditMode: false,

  isVisible: false,
  noImageUrl: "",
  status: "None"
};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.showingDetailId) return INVISIBLE_PROPS;

    const detail = localState.detail[localState.showingDetailId]!;

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      id: props.id,
      isEditMode: state.isEditMode,
      detail: detail.detail,
      isVisible: true,
      noImageUrl: getNoImageUrl(),
      status: detail.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setShowingDetailId({ ...getEntityRef(props), itemId: null })),
  onDownloadClick: () => dispatch(downloadInvoice(getEntityRef(props))),

  onUpdate: (data: MemberRecurringOrders.View.UpdateDetail) => dispatch(updateDetail(getEntityRef(props), data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
